import { render, staticRenderFns } from "./ButtonsAnswer.vue?vue&type=template&id=0657d964&scoped=true&"
import script from "./ButtonsAnswer.vue?vue&type=script&lang=js&"
export * from "./ButtonsAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsAnswer.vue?vue&type=style&index=0&id=0657d964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657d964",
  null
  
)

export default component.exports